
import "./education.css";
import React from "react";
import { LiaGlobeAfricaSolid } from "react-icons/lia";
import { FaUserTie, FaHandshake, FaStar, FaBullhorn } from "react-icons/fa";
import { MdLock, MdBarChart } from "react-icons/md";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { FaStarOfDavid } from "react-icons/fa";
import { MdPersonSearch } from "react-icons/md";
import { BsFillTrophyFill } from "react-icons/bs";


const iconMap = {
  LiaGlobeAfricaSolid: LiaGlobeAfricaSolid,
  FaUserTie: FaUserTie,
  MdPersonSearch: MdPersonSearch,
  MdLock: MdLock,
  MdBarChart: MdBarChart,
  AiOutlineDollarCircle: AiOutlineDollarCircle,
  FaHandshake: FaHandshake,
  BsFillTrophyFill:BsFillTrophyFill,
  FaStar: FaStar,
  FaBullhorn: FaBullhorn,
  FaStarOfDavid: FaStarOfDavid
};

function getIconComponent(iconName) {
  return iconMap[iconName] || null;
}

function Education() {
  const data = [
    {
      heading: "Expand Your Reach Internationally",
      content:
        "Connect with a global network of logistics and supply chain professionals seeking advanced education and certification. Logiglos international platform ensures your courses reach a diverse worldwide audience.",
      icon: "LiaGlobeAfricaSolid",
      size: "1.4em",
    },
    {
      heading: "Dedicated Platform for Industry Professionals",
      content:
        "Tap into a niche market of dedicated logistics and supply chain experts who are actively seeking to upskill and advance their careers. Logiglo is designed specifically for this sector, offering a targeted audience for your courses.",
      icon: "FaUserTie",
      size: "1.4em",
    },
    {
      heading: "Enhanced Visibility with Global SEO",
      content:
        "Benefit from Logiglo's robust global SEO optimization, designed to increase the visibility of your courses. Enhance your institution’s global presence and attract more students interested in logistics and supply chain management.",
      icon: "MdPersonSearch",
      size: "1.6em",
    },
    {
      heading: "Secured and Spam-Free Environment",
      content:
        "Rest assured that your course offerings will be showcased in a secure, spam-free environment. Logiglo prioritizes security and quality, providing a trustworthy platform for both educators and learners.",
      icon: "MdLock",
      size: "1.4em",
    },
    {
      heading: "Comprehensive Analytics and Insights",
      content:
        "Gain access to detailed analytics and insights about course performance, learner engagement, and market trends. Use this data to refine your offerings and better meet the needs of the logistics and supply chain community.",
      icon: "MdBarChart",
      size: "1.3em",
    },
    {
      heading: "Streamlined Enrollment and Payment Systems",
      content:
        "Enjoy a seamless registration and payment process for both you and your students. Logiglo's user-friendly systems make it easy to manage course enrollments, track payments, and provide a smooth user experience.",
      icon: "AiOutlineDollarCircle",
      size: "1.2em",
    },
    {
      heading: "Collaborate with Industry Leaders",
      content:
        "Partner with other leading institutions and industry experts on Logiglo. Share best practices, collaborate on joint courses, and enhance your educational offerings by leveraging the collective expertise within the platform.",
      icon: "FaHandshake",
      size: "1.4em",
    },
    {
      heading: "Showcase Your Institution’s Expertise",
      content:
        "Highlight your institution's credentials, faculty expertise, and unique course offerings on a global stage. Build your reputation as a leader in logistics and supply chain education.",
      icon: "BsFillTrophyFill",
      size: "1.2em",
    },
    {
      heading: "Customized Marketing and Promotional Support",
      content:
        "Benefit from Logiglo’s tailored marketing and promotional tools designed to boost the visibility of your courses. Leverage targeted campaigns, featured listings, and promotional events to attract more students.",
      icon: "FaBullhorn",
      size: "1.2em",
    },
    {
      heading: "Commitment to Quality and Continuous Improvement",
      content:
        "Join a platform dedicated to the highest standards of education and continuous improvement. Logiglo is committed to supporting your institution in delivering top-notch logistics and supply chain courses that meet evolving industry demands.",
      icon: "FaStar",
      size: "1.2em",
    },
  ];

  return (
    <div className="education-container">
      <div className="left">
        <h2 className="main-heading">
          Unlock Global Opportunities for Your Logistics and Supply Chain Courses with Logiglo
        </h2>
        <ul className="education-ul">
          {data.map((item, i) => {
            const IconComponent = getIconComponent(item.icon);

            return (
              <li
                key={i}
                style={{
                  listStyle: "none",
                  display: "flex",
                  flexDirection: "row",
                  height: "fit-content",
                  width: "fit-content",
                  columnGap: 6,
                  alignItems: "center",
                }}
              >
                <div className="icon-new">
                {IconComponent && <IconComponent style={{ width: item.size, height: item.size, marginRight: '10px',transform: 'translateY(10%)' }} />}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    height: "fit-content",
                    width: "90%",
                    marginBottom: "0px",
                  }}
                >
                  <div className="inner-container">
                    <h4 className="sub-heading">{item.heading}</h4>
                    <p>{item.content}</p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default Education;
